import React from "react";
import { Modal } from "antd";
import { Button } from "reactstrap";
import "./customModalV2.css";

const icon = {
  success: "icon-ok-modalpopup icons-front-module green",
  error: "icon-error-modalpopup icons-front-module red",
  alert: "icon-important-comment icons-front-module deep",
};

const createModal = ({
  type,
  titleModal,
  isModalOpen,
  onCancel,
  message,
  component,
  width,
  buttons,
  destroyOnClose,
}) => {
  // Variable mutable para controlar el estado de los botones deshabilitados
  const disabledButtons = new Set();

  const handleButtonClick = (button, index) => {
    if (!button.disabled) {
      // Marcar el botón como deshabilitado
      disabledButtons.add(index);

      // Deshabilitar visualmente el botón
      const buttonElement = document.querySelector(`#button-${index}`);
      if (buttonElement) {
        buttonElement.setAttribute("disabled", true);
      }
    }

    // Ejecutar la lógica del botón
    if (button.onClick) button.onClick();
  };

  const renderButtons = () => {
    return buttons?.map((button, index) => (
      <Button
        key={index}
        id={`button-${index}`}
        className="float-right custom-width-btn ml-2"
        onClick={() => handleButtonClick(button, index)}
        color={button.type}
        disabled={button.disabled || disabledButtons.has(index)}
        size="sm"
      >
        {button.text}
      </Button>
    ));
  };

  // Reiniciar el estado de los botones al abrir el modal
  if (isModalOpen) {
    disabledButtons.clear();
    if (buttons?.length > 0) {
      buttons.forEach((_, index) => {
        const buttonElement = document.querySelector(`#button-${index}`);
        if (buttonElement) {
          buttonElement.removeAttribute("disabled");
        }
      });
    }
  }

  return (
    <Modal
      open={isModalOpen}
      className="custom-modal"
      closeIcon={
        <i
          onClick={() => onCancel()}
          style={{ fontSize: "12px", cursor: "pointer" }}
          className="icon-cancel-1"
        />
      }
      closable
      width={width || "420px"}
      footer={null}
      destroyOnClose={destroyOnClose || false}
    >
      {/* Header */}
      <div className="custom-modal-header">
        <span className={type ? icon[type] : icon["alert"]} />
        <p className="modal-title pb-2">{titleModal}</p>
      </div>
      {/* Body */}
      <div className="modal-body">
        {message && <p className="modal-message">{message}</p>}
        {component}
      </div>
      {/* Footer */}
      {buttons ? <div className="btns-modal-container pb-4">{renderButtons()}</div> : false}
    </Modal>
  );
};

export default createModal;